import { useState, useEffect } from 'react';
import { addDoc, collection, getDocs, getDoc, doc, updateDoc, setDoc } from 'firebase/firestore'
import { FiEdit3 } from 'react-icons/fi'
import { toast } from 'react-toastify'

import { Header } from '../../components/Header'
import { Title } from '../../components/Title'

import { db } from '../../services/firebaseConnection'
import { AuthContext } from '../../contexts/auth'

import { Content } from "./styles";

const listCollection = collection(db, "discipline")

export function RegisterCategory() {
  const [discipline, setDiscipline] = useState('')
  const [subject, setSubject] = useState('')
  const [organizer, setOrganizer] = useState('')
  const [institution, setInstitution] = useState('')
  const [profession, setProfession] = useState('')
  const [workspace, setWorkspace] = useState('')
  const [professionalQualification, setProfessionalQualification] = useState('')

  const [loadingDiscipline, setLoadingDiscipline] = useState(true)
  const [getDiscipline, setGetDiscipline] = useState([])
  //console.log(getDiscipline)
  const [disciplineSelected, setDisciplineSelected] = useState('')
  const [disciplineSelectedId, setDisciplineSelectedId] = useState('')
  console.log(disciplineSelectedId)
  //console.log(disciplineSelected)

  // getDiscipline.map((i) => {
  //   console.log(i.discipline)
  // })

  useEffect(() => {
    async function loadDiscipline() {
      const querySnapshot = await getDocs(listCollection)
        .then((snapshot) => {
          //console.log(snapshot.docs)
          let list = []

          snapshot.forEach((doc) => {
            list.push({
              id: doc.id,
              discipline: doc.data().discipline
            })

            //console.log(list)
            if (snapshot.docs.size === 0) {
              console.log("Nenhum discipina encontrada")
              setGetDiscipline([{ id: '1', discipline: 'Disciplina' }])
              setLoadingDiscipline(false)
              return
            }

            // list.map((a) => {
            //   console.log(a)
            // })

            setGetDiscipline(list)
            setLoadingDiscipline(false)
          })
        })
        .catch((err) => {
          console.log(err)
          setLoadingDiscipline(false)
          setGetDiscipline([{ id: '1', discipline: "Disciplina" }])
        })
    }

    loadDiscipline()
  }, [discipline])

  async function handleRegisterDiscipline(e) {
    e.preventDefault()

    if (discipline !== '') {
      await addDoc(collection(db, "discipline"), {
        discipline: discipline,
        created: new Date()
      })
        .then(() => {
          setDiscipline('')
          toast.success("Disciplina cadastrada co sucesso")
        })
        .catch((err) => {
          console.log(err)
          toast.error("Erro ao cadastrar nova disciplina")
        })
    } else {
      toast.error("Preencha todos os campos")
    }
  }

  async function handleRegisterDisciplineSubject(e) {
    e.preventDefault()

    if (subject !== '' || disciplineSelected !== '') {
      await addDoc(collection(db, "subject"), {
        discipline: disciplineSelected,
        subject: subject,
        created: new Date()
      })
        .then(() => {
          setSubject('')
          toast.success("Assunto cadastrada com sucesso")
        })
        .catch((err) => {
          console.log(err)
          toast.error("Erro ao cadastrar nova assunto")
        })
    } else {
      toast.error("Preencha todos os campos")
    }
  }

  async function handleRegisterOrganizer(e) {
    e.preventDefault()

    if (organizer !== '') {
      await addDoc(collection(db, "organizer"), {
        organizer: organizer,
        created: new Date()
      })
        .then(() => {
          setOrganizer('')
          toast.success("Banca cadastrada com sucesso")
        })
        .catch((err) => {
          console.log(err)
          toast.error("Erro ao cadastrar nova banca")
        })
    } else {
      toast.error("Preencha todos os campos")
    }
  }

  async function handleRegisterInstitution(e) {
    e.preventDefault()

    if (institution !== '') {
      await addDoc(collection(db, "institution"), {
        institution: institution,
        created: new Date()
      })
        .then(() => {
          setInstitution('')
          toast.success("Instituição cadastrada com sucesso")
        })
        .catch((err) => {
          console.log(err)
          toast.error("Erro ao cadastrar nova instituição")
        })
    } else {
      toast.error("Preencha todos os campos")
    }
  }

  async function handleRegisterProfession(e) {
    e.preventDefault()

    if (profession !== '') {
      await addDoc(collection(db, "profession"), {
        profession: profession,
        created: new Date()
      })
        .then(() => {
          setProfession('')
          toast.success("Cargo cadastrada com sucesso")
        })
        .catch((err) => {
          console.log(err)
          toast.error("Erro ao cadastrar novo cargo")
        })
    } else {
      toast.error("Preencha todos os campos")
    }
  }

  async function handleRegisterProfessionalQualification(e) {
    e.preventDefault()

    if (professionalQualification !== '') {
      await addDoc(collection(db, "professionalQualification"), {
        professionalQualification: professionalQualification,
        created: new Date()
      })
        .then(() => {
          setProfessionalQualification('')
          toast.success("Cargo cadastrada com sucesso")
        })
        .catch((err) => {
          console.log(err)
          toast.error("Erro ao cadastrar novo cargo")
        })
    } else {
      toast.error("Preencha todos os campos")
    }
  }

  async function handleRegisterWorkspace(e) {
    e.preventDefault()

    if (workspace !== '') {
      await addDoc(collection(db, "workspace"), {
        workspace: workspace,
        created: new Date()
      })
        .then(() => {
          setWorkspace('')
          toast.success("Area de trabalho cadastrada com sucesso")
        })
        .catch((err) => {
          console.log(err)
          toast.error("Erro ao cadastrar nova area de trabalho")
        })
    } else {
      toast.error("Preencha todos os campos")
    }
  }

  function handleChangeDiscipline(e) {
    setDisciplineSelected(getDiscipline[e.target.value].discipline)
    setDisciplineSelectedId(getDiscipline[e.target.value].id)
  }

  return (
    <>
      <Header />
      <Content>
        <Title name="Cadastrar Questão">
          <FiEdit3 size={25} />
        </Title>

        <div className='container'>
          <form onSubmit={handleRegisterDiscipline}>
            <label>Nova Disciplina</label>
            <input
              placeholder='digite o nome da nova disciplina'
              value={discipline}
              onChange={(e) => setDiscipline(e.target.value)}
            />
            <button type='submit'>Cadastrar</button>
          </form>
          <div className='box-subject'>
            <form >
              <label>Selecione a Disciplina</label>

              {
                loadingDiscipline ? (
                  <input type='text' disabled={true} value="Carregando..." />
                ) : (
                  <select value={disciplineSelected} onChange={handleChangeDiscipline} >

                    {getDiscipline.map((item, index) => {
                      return (
                        <option key={index} value={index} >{item.discipline}</option>
                      )
                    })}

                  </select>
                )
              }

              {/* <select>
                <option>Diciplina1</option>
                <option>Diciplina2</option>
                <option>Diciplina3</option>
              </select> */}
              {/* <button type='submit'>Cadastrar</button> */}
            </form>
            <form onSubmit={handleRegisterDisciplineSubject}>
              <label>Novo Assunto</label>
              <input
                placeholder='digite o nome do novo assunto'
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
              <button type='submit'>Cadastrar</button>
            </form>
          </div>

          <form onSubmit={handleRegisterOrganizer}>
            <label>Nova Banca</label>
            <input
              placeholder='digite o nome do novo assunto'
              value={organizer}
              onChange={(e) => setOrganizer(e.target.value)}
            />
            <button type='submit'>Cadastrar</button>
          </form>
          <form onSubmit={handleRegisterInstitution}>
            <label>Nova Instituição</label>
            <input
              placeholder='digite o nome da nova instituição'
              value={institution}
              onChange={(e) => setInstitution(e.target.value)}
            />
            <button type='submit'>Cadastrar</button>
          </form>
          <form onSubmit={handleRegisterProfession}>
            <label>Novo Cargo</label>
            <input
              placeholder='digite o nome do novo cargo'
              value={profession}
              onChange={(e) => setProfession(e.target.value)}
            />
            <button type='submit'>Cadastrar</button>
          </form>
          <form onSubmit={handleRegisterProfessionalQualification}>
            <label>Nova Área de Formação</label>
            <input
              placeholder='digite a nova area de formação'
              value={professionalQualification}
              onChange={(e) => setProfessionalQualification(e.target.value)}
            />
            <button type='submit'>Cadastrar</button>
          </form>
          <form onSubmit={handleRegisterWorkspace}>
            <label>Nova Área de Trabalho</label>
            <input
              placeholder='digite a nova area de trabalho'
              value={workspace}
              onChange={(e) => setWorkspace(e.target.value)}
            />
            <button type='submit'>Cadastrar</button>
          </form>
        </div>
      </Content>
    </>
  )
}